import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

import PanelWithTitleAndIcon from '../../common/PanelWithTitleAndIcon';

import { recommendationRelations, Recommendation } from '../MatchModel';
import tr from '../../localization/translate';

import recommendationsIcon from '../../assets/images/recommendations.svg';
import './Recommendations.scss';

function title(asSharedProfile) {
  if (asSharedProfile) {
    return tr('simple_pages.share_profile.recommendations.title');
  }

  return tr('matching.recommendations.title');
}

function note(count) {
  if (count > 1) {
    return tr('matching.recommendations.title_note', { count });
  }

  return '';
}

function noRecommendations(asSharedProfile) {
  if (asSharedProfile) {
    return tr('simple_pages.share_profile.recommendations.no_recommendations');
  }

  return tr('matching.recommendations.no_recommendations');
}

function trRelation(relation) {
  switch (relation) {
    case recommendationRelations.COWORKER: return tr('common.recommendation_relations.coworker');
    case recommendationRelations.FAMILY_MEMBER: return tr('common.recommendation_relations.family');
    case recommendationRelations.FRIEND: return tr('common.recommendation_relations.friend');
    case recommendationRelations.LANDLORD: return tr('common.recommendation_relations.landlord');
    default: return tr('common.recommendation_relations.unset');
  }
}

function genRecommendationItems(list, asSharedProfile) {
  if (list.size === 0) {
    return (
      <div styleName="no_recommendations">
        <p className="heavy_text">{ noRecommendations(asSharedProfile) }</p>
      </div>
    );
  }

  return list.map(item => (
    <div styleName="item" key={item.recommendation_id}>
      <div styleName="info">
        <p className="heavy_text">{ item.name }</p>
        <p className="text rem_0_875">{ trRelation(item.relation) }</p>
      </div>

      <p className="text tall_lines" styleName="why">{ item.why }</p>
    </div>
  ));
}

function RentalHistory({ asSharedProfile, recommendations }) {
  return (
    <PanelWithTitleAndIcon
      icon={recommendationsIcon}
      title={title(asSharedProfile)}
      note={note(recommendations.size)}
    >
      { genRecommendationItems(recommendations, asSharedProfile) }
    </PanelWithTitleAndIcon>
  );
}

RentalHistory.propTypes = {
  asSharedProfile: PropTypes.bool,
  recommendations: ImmutablePropTypes.listOf(Recommendation.propType).isRequired
};

RentalHistory.defaultProps = {
  asSharedProfile: false
};

export default RentalHistory;
